import { useEffect, useState } from 'react';
import type { RoadmapResponse } from '@journeyapps/package-types';

export const useRoadmap = () => {
  const [roadmap, setRoadmap] = useState<RoadmapResponse | null>(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setError(false);
    setRoadmap(null);

    const load = async () => {
      try {
        const response = await fetch('/api/roadmap', { signal: controller.signal, cache: 'no-store' });
        if (!response.ok) throw new Error('Roadmap unavailable');
        const data: RoadmapResponse = await response.json();
        if (!controller.signal.aborted) setRoadmap(data);
      } catch {
        if (!controller.signal.aborted) setError(true);
      }
    };
    void load();
    return () => controller.abort();
  }, [attempt]);

  return { roadmap, error, reload: () => setAttempt((attempt) => attempt + 1) };
};
